import { Pattern } from "../lib/types";
import { cn } from "../lib/utils";
import { Badge } from "./ui/badge";
import { Star, Heart, Download, Check } from "lucide-react";

interface PatternSelectorProps {
  patterns: Pattern[];
  selectedPattern: Pattern | null;
  onSelect: (pattern: Pattern) => void;
}

export function PatternSelector({ patterns, selectedPattern, onSelect }: PatternSelectorProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-2 sm:gap-4 lg:grid-cols-3">
        {patterns.map((pattern) => (
          <div
            key={pattern.id}
            className={cn(
              "pattern-card",
              selectedPattern?.id === pattern.id && "selected"
            )}
            onClick={() => onSelect(pattern)}
          >
            <div className="aspect-square bg-gray-100 flex items-center justify-center rounded-lg relative">
              <img
                src={pattern.imageUrl}
                alt={pattern.name}
                className="w-full h-full object-cover rounded-lg"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  target.parentElement!.innerHTML = `
                    <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg">
                      <div class="text-center">
                        <div class="w-8 h-8 bg-gray-300 rounded mx-auto mb-1"></div>
                        <p class="text-xs text-gray-500">${pattern.name}</p>
                      </div>
                    </div>
                  `;
                }}
              />
              {selectedPattern?.id === pattern.id && (
                <div className="absolute top-2 right-2 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                  <Check className="h-4 w-4 text-white" />
                </div>
              )}
            </div>
            <div className="p-2 sm:p-3">
              <div className="flex items-start justify-between mb-1 sm:mb-2">
                <h3 className="font-medium text-gray-900 text-xs sm:text-sm truncate">
                  {pattern.name}
                </h3>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <Star className="h-3 w-3 text-yellow-400 fill-current" />
                  <span className="text-xs text-gray-500 hidden sm:inline">4.8</span>
                </div>
              </div>
              <p className="text-xs text-gray-600 line-clamp-1 sm:line-clamp-2 mb-1 sm:mb-2">
                {pattern.description}
              </p>
              <div className="flex items-center justify-between">
                <Badge variant="outline" className="text-xs">Premium</Badge>
                <div className="flex gap-1 sm:flex hidden">
                  <button className="p-1 hover:bg-gray-100 rounded opacity-50 cursor-not-allowed">
                    <Heart className="h-3 w-3 text-gray-400" />
                  </button>
                  <button className="p-1 hover:bg-gray-100 rounded opacity-50 cursor-not-allowed">
                    <Download className="h-3 w-3 text-gray-400" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 